export default "__VITE_ASSET__DZFipOqD__"